/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */

const timestampToTime = (timestamp) => {
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-'
    let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
    let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
};
const isRepeat = (v) => {
    let obj = {}
    for (let i in v) {
        if (obj[v[i]]) {
            return true
        }
        obj[v[i]] = true
    }
    return false
};
function downloadFile(url, name) {
    //下载地址和名称
    var image = new Image();
    // 解决跨域 Canvas 污染问题
    image.setAttribute("crossOrigin", "anonymous");
    image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var imgUrl = canvas.toDataURL("image/png"); //得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = imgUrl; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
    };
    image.src = url;
};

// 删除图片 list 图片数组   删除图片ID idList 图片ID数组
function removeImage(file, list,idList) {
    list.forEach((i, index) => {
        if (i.fileId === file.fileId) {
            list.splice(index, 1);
        }
    });
    idList.forEach((i,index)=>{
        if (i === file.fileId) {
            idList.splice(index, 1);
        }
    })
};

const dateAddOne = (timestamp) => {
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-'
    let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    return Y + M + D + "23:59:59"
};
const dateTransition = (timestamp) => {
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-'
    let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ''
    return Y + M + D
};
// 判断一个字符串末尾是否以某个字符结尾
function confirmEnding(str, target) {
    // str 传过来的字符串   traget 需要判断的结尾字符
    var arr = str.replace(/\s+/g, "");
    var bb = arr.substr(arr.length - target.length, arr.length);
    if (bb == target) return true;
    else return false;
};
/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
    let date = new Date();
    date.setDate(date.getDate() + day);
    document.cookie = name + '=' + value + ';expires=' + date;
};

/**
 * 获取cookie
 **/
function getCookie(name) {
    let reg = RegExp(name + '=([^;]+)');
    let arr = document.cookie.match(reg);
    if (arr) {
        return arr[1];
    } else {
        return '';
    }
};

/**
 * 删除cookie
 **/
function delCookie(name) {
    setCookie(name, null, -1);
};

// 引入转换 excel 的文件
const { export_json_to_excel } = require('./Export2Excel')

// 导出列表格式化数据的方法
function formatJson(filterVal, jsonData) {
    return jsonData.map((v) => filterVal.map((j) => v[j]));
};

// 导出excel
function exportExcel(tHeader, filterVal, tableData, name) {
    const data = formatJson(filterVal, tableData);
    export_json_to_excel(
        tHeader,
        data,
        name + new Date().toLocaleDateString()
    );
};

//文件校验方法
function beforeAvatarUpload(file) {
    // 通过split方法和fileArr方法获取到文件的后缀名
    let fileArr = file.name.split(".");
    let suffix = fileArr[fileArr.length - 1];
    //只能导入.xls和.xlsx文件
    if (!/(xls|xlsx)/i.test(suffix)) {

        this.$message.info("文件格式不正确");
        return false;
    }
    return true;
}

/**
 * 把需要暴露的方法 函数 暴露出去 
 **/
export {
    timestampToTime,
    dateAddOne,
    dateTransition,
    confirmEnding,
    setCookie,
    getCookie,
    delCookie,
    exportExcel,
    beforeAvatarUpload,
    isRepeat,
    downloadFile,
    removeImage
}


// WEBPACK FOOTER //
// ./src/utils/util.js